import { render } from "./welHome.vue?vue&type=template&id=74093b0a&scoped=true"
import script from "./welHome.vue?vue&type=script&lang=js"
export * from "./welHome.vue?vue&type=script&lang=js"

import "./welHome.vue?vue&type=style&index=0&id=74093b0a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74093b0a"]])

export default __exports__